// @core/api/endpoints/resource/list_links.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLinksResponse,
} from '../../../types/resource';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/resource';

/**
 * List links for a resource
 * Returns links connected to a resource. Use 'direction' to filter: INCOMING (what references me?), OUTGOING (what do I reference?), or BOTH (all links). Supports filtering by relation type and resource type.
 */
export async function ListLinks(
  resource_type: string,
  resource_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLinksResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_type/:resource_id/links`;
  requestPath = requestPath.replace(':resource_type', encodeURIComponent(resource_type));
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<ListLinksResponse>(requestPath, { ...requestOptions, params });
}
